module.exports = __webpack_public_path__ + "img/logo-blue.5a90470.png";